import { PayloadAction } from '@reduxjs/toolkit';
import { BLAdmin } from '@/types/profile.types';
import { ProjectStateReducerCreator } from '../types';

const updateCrewAdminChannelsReducer = (create: ProjectStateReducerCreator) => {
  return create.reducer((state, action: PayloadAction<{ adminId: number; updatedAdmin: BLAdmin }>) => {
    const { adminId, updatedAdmin } = action.payload;
    if (state.workingProject?.sessions.length) {
      for (const session of state.workingProject.sessions) {
        if (!session.crew) continue;
        const crewMember = session.crew.find((c) => c.bl_admin.id === adminId);
        if (crewMember) {
          crewMember.bl_admin.channels = updatedAdmin.channels;
        }
      }
    }
  });
};

export default updateCrewAdminChannelsReducer;
